import { render, staticRenderFns } from "./InventoryHistory.vue?vue&type=template&id=4ee47572&scoped=true&"
import script from "./InventoryHistory.vue?vue&type=script&lang=js&"
export * from "./InventoryHistory.vue?vue&type=script&lang=js&"
import style0 from "./InventoryHistory.vue?vue&type=style&index=0&id=4ee47572&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee47572",
  null
  
)

export default component.exports